import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceDot,
} from "recharts";

// ─── STOCKS ─────────────────────────────────────────────────────────────────
const ALL_STOCKS = [
  {
    ticker: "JPM",
    name: "JPMorgan Chase",
    sector: "Banking",
    yield: 2.0,
    appreciation: 9,
    dgr: 8,
  },
  {
    ticker: "XOM",
    name: "Exxon Mobil",
    sector: "Energy",
    yield: 2.47,
    appreciation: 6,
    dgr: 4,
  },
  {
    ticker: "V",
    name: "Visa",
    sector: "Finance",
    yield: 0.83,
    appreciation: 12,
    dgr: 15,
  },
  {
    ticker: "JNJ",
    name: "Johnson & Johnson",
    sector: "Healthcare",
    yield: 2.17,
    appreciation: 6,
    dgr: 5,
  },
  {
    ticker: "MA",
    name: "Mastercard",
    sector: "Finance",
    yield: 0.65,
    appreciation: 13,
    dgr: 14,
  },
  {
    ticker: "COST",
    name: "Costco Wholesale",
    sector: "Retail",
    yield: 0.53,
    appreciation: 11,
    dgr: 12,
  },
  {
    ticker: "CVX",
    name: "Chevron",
    sector: "Energy",
    yield: 3.37,
    appreciation: 6,
    dgr: 5,
  },
  {
    ticker: "ABBV",
    name: "AbbVie",
    sector: "Healthcare",
    yield: 3.25,
    appreciation: 7,
    dgr: 8,
  },
  {
    ticker: "BAC",
    name: "Bank of America",
    sector: "Banking",
    yield: 2.26,
    appreciation: 8,
    dgr: 9,
  },
  {
    ticker: "CAT",
    name: "Caterpillar",
    sector: "Industrial",
    yield: 0.83,
    appreciation: 9,
    dgr: 8,
  },
  {
    ticker: "PG",
    name: "Procter & Gamble",
    sector: "Consumer",
    yield: 2.94,
    appreciation: 7,
    dgr: 5,
  },
  {
    ticker: "HD",
    name: "Home Depot",
    sector: "Retail",
    yield: 2.78,
    appreciation: 8,
    dgr: 10,
  },
  {
    ticker: "KO",
    name: "Coca-Cola",
    sector: "Consumer",
    yield: 2.74,
    appreciation: 6,
    dgr: 4,
  },
  {
    ticker: "CSCO",
    name: "Cisco Systems",
    sector: "Tech",
    yield: 2.02,
    appreciation: 6,
    dgr: 3,
  },
  {
    ticker: "GE",
    name: "GE Aerospace",
    sector: "Industrial",
    yield: 0.52,
    appreciation: 10,
    dgr: 6,
  },
  {
    ticker: "MRK",
    name: "Merck & Co",
    sector: "Healthcare",
    yield: 2.78,
    appreciation: 6,
    dgr: 6,
  },
  {
    ticker: "RTX",
    name: "RTX Corporation",
    sector: "Defense",
    yield: 1.39,
    appreciation: 8,
    dgr: 7,
  },
  {
    ticker: "MS",
    name: "Morgan Stanley",
    sector: "Finance",
    yield: 2.37,
    appreciation: 9,
    dgr: 10,
  },
  {
    ticker: "PM",
    name: "Philip Morris Intl",
    sector: "Consumer",
    yield: 3.48,
    appreciation: 5,
    dgr: 3,
  },
  {
    ticker: "GS",
    name: "Goldman Sachs",
    sector: "Finance",
    yield: 1.84,
    appreciation: 10,
    dgr: 12,
  },
  {
    ticker: "WFC",
    name: "Wells Fargo",
    sector: "Banking",
    yield: 2.18,
    appreciation: 8,
    dgr: 7,
  },
  {
    ticker: "UNH",
    name: "UnitedHealth Group",
    sector: "Healthcare",
    yield: 3.27,
    appreciation: 8,
    dgr: 12,
  },
  {
    ticker: "TMUS",
    name: "T-Mobile US",
    sector: "Telecom",
    yield: 1.86,
    appreciation: 9,
    dgr: 0,
  },
  {
    ticker: "LIN",
    name: "Linde PLC",
    sector: "Chemicals",
    yield: 1.24,
    appreciation: 8,
    dgr: 9,
  },
  {
    ticker: "IBM",
    name: "IBM",
    sector: "Tech",
    yield: 2.78,
    appreciation: 5,
    dgr: 2,
  },
  {
    ticker: "MCD",
    name: "McDonald’s",
    sector: "Consumer",
    yield: 2.33,
    appreciation: 7,
    dgr: 7,
  },
  {
    ticker: "VZ",
    name: "Verizon",
    sector: "Telecom",
    yield: 5.49,
    appreciation: 3,
    dgr: 2,
  },
  {
    ticker: "PEP",
    name: "PepsiCo",
    sector: "Consumer",
    yield: 3.75,
    appreciation: 6,
    dgr: 7,
  },
  {
    ticker: "AXP",
    name: "American Express",
    sector: "Finance",
    yield: 1.14,
    appreciation: 11,
    dgr: 10,
  },
  {
    ticker: "T",
    name: "AT&T",
    sector: "Telecom",
    yield: 3.85,
    appreciation: 3,
    dgr: 1,
  },
  {
    ticker: "O",
    name: "Realty Income",
    sector: "REIT",
    yield: 5.38,
    appreciation: 5,
    dgr: 3,
  },
  {
    ticker: "MSFT",
    name: "Microsoft",
    sector: "Tech",
    yield: 0.96,
    appreciation: 10,
    dgr: 10,
  },
  {
    ticker: "AAPL",
    name: "Apple",
    sector: "Tech",
    yield: 0.41,
    appreciation: 11,
    dgr: 6,
  },
  {
    ticker: "AVGO",
    name: "Broadcom",
    sector: "Tech",
    yield: 0.78,
    appreciation: 11,
    dgr: 12,
  },
  {
    ticker: "NVDA",
    name: "NVIDIA",
    sector: "Tech",
    yield: 0.02,
    appreciation: 15,
    dgr: 10,
  },
];

const FEATURED = [
  { ticker: "KO", label: "Coca-Cola", tag: "60yr streak" },
  { ticker: "PEP", label: "PepsiCo", tag: "52yr streak" },
  { ticker: "JNJ", label: "J&J", tag: "62yr streak" },
  { ticker: "PG", label: "Procter & Gamble", tag: "68yr streak" },
  { ticker: "MS", label: "Morgan Stanley", tag: "Wall St icon" },
  { ticker: "JPM", label: "JPMorgan", tag: "Top bank" },
  { ticker: "MCD", label: "McDonald’s", tag: "47yr streak" },
  { ticker: "XOM", label: "ExxonMobil", tag: "Energy giant" },
  { ticker: "CVX", label: "Chevron", tag: "36yr streak" },
  { ticker: "ABBV", label: "AbbVie", tag: "High yield" },
  { ticker: "VZ", label: "Verizon", tag: "5.49% yield" },
  { ticker: "O", label: "Realty Income", tag: "Monthly divs" },
];

const SECTOR_COLORS = {
  Tech: "#60a5fa",
  Banking: "#34d399",
  Finance: "#a78bfa",
  Healthcare: "#f472b6",
  Energy: "#fb923c",
  Consumer: "#fbbf24",
  Industrial: "#94a3b8",
  Defense: "#c084fc",
  Utilities: "#4ade80",
  REIT: "#f87171",
  Telecom: "#38bdf8",
  Insurance: "#e879f9",
  Chemicals: "#86efac",
  Materials: "#fcd34d",
  Retail: "#67e8f9",
  Travel: "#fdba74",
  Auto: "#a3e635",
  Construction: "#d4d4d8",
};

const fmt = (n) =>
  n >= 1_000_000
    ? `$${(n / 1_000_000).toFixed(2)}M`
    : n >= 1_000
    ? `$${(n / 1_000).toFixed(1)}K`
    : `$${Math.round(n)}`;
const fmtFull = (n) => `$${Math.round(n).toLocaleString()}`;

// ─── URL PARAMS ──────────────────────────────────────────────────────────────
function readParams() {
  try {
    if (typeof window === "undefined" || !window.location?.search)
      return {
        ticker: "KO",
        start: 5000,
        monthly: 300,
        years: 25,
        appreciation: null,
        dgr: null,
        taxDrag: false,
        inflation: false,
      };
    const p = new URLSearchParams(window.location.search);
    const ticker = p.get("ticker") || "KO";
    const validTicker = ALL_STOCKS.find((s) => s.ticker === ticker)
      ? ticker
      : "KO";
    return {
      ticker: validTicker,
      start: Math.max(500, parseInt(p.get("start")) || 5000),
      monthly: Math.max(0, parseInt(p.get("monthly")) || 300),
      years: Math.min(40, Math.max(5, parseInt(p.get("years")) || 25)),
      appreciation: p.get("appr") ? parseFloat(p.get("appr")) : null,
      dgr: p.get("dgr") ? parseFloat(p.get("dgr")) : null,
      taxDrag: p.get("tax") === "1",
      inflation: p.get("inf") === "1",
    };
  } catch {
    return {
      ticker: "KO",
      start: 5000,
      monthly: 300,
      years: 25,
      appreciation: null,
      dgr: null,
      taxDrag: false,
      inflation: false,
    };
  }
}

function buildShareURL(
  ticker,
  start,
  monthly,
  years,
  appr,
  baseAppr,
  dgr,
  baseDgr,
  taxDrag,
  inflation
) {
  try {
    const base = window.location.href.split("?")[0];
    const p = new URLSearchParams({ ticker, start, monthly, years });
    if (appr !== null && appr !== baseAppr) p.set("appr", appr);
    if (dgr !== null && dgr !== baseDgr) p.set("dgr", dgr);
    if (taxDrag) p.set("tax", "1");
    if (inflation) p.set("inf", "1");
    return `${base}?${p.toString()}`;
  } catch {
    return window.location.href;
  }
}

// ─── SIMULATION ──────────────────────────────────────────────────────────────
function runSim({
  start,
  monthly,
  yieldPct,
  appreciation,
  years,
  dgr,
  taxDrag,
  inflation,
}) {
  const POINTS = 80,
    step = years / POINTS;
  const milestones = [50000, 100000, 250000, 500000, 1000000, 2000000, 5000000];
  const milestoneHits = {};
  let snowballYear = null;

  let sharePrice = start / 1000;
  let divPerShare = sharePrice * (yieldPct / 100);
  let dripShares = 1000,
    noDripShares = 1000;
  let totalContrib = start;

  const data = [];

  for (let i = 0; i <= POINTS; i++) {
    const yr = parseFloat((i * step).toFixed(3));

    // Adjust values for 3% historical inflation if toggled
    const infFactor = inflation ? Math.pow(1.03, yr) : 1;

    const currentDripValue = (dripShares * sharePrice) / infFactor;
    const currentNoDripValue = (noDripShares * sharePrice) / infFactor;
    const annualDiv = (dripShares * divPerShare) / infFactor;

    if (snowballYear === null && yr > 0.5 && annualDiv >= monthly * 12)
      snowballYear = Math.round(yr);
    milestones.forEach((m) => {
      if (!milestoneHits[m] && currentDripValue >= m)
        milestoneHits[m] = Math.round(yr);
    });

    data.push({
      yr: Math.round(yr * 10) / 10,
      drip: Math.round(currentDripValue),
      noDrip: Math.round(currentNoDripValue),
      dividends: annualDiv,
    });

    const priceGrowth = Math.pow(1 + appreciation / 100, step);
    const divGrowth = Math.pow(1 + dgr / 100, step);

    const contribShares = (monthly * 12 * step) / sharePrice;

    // Apply 15% tax drag to reinvested dividends if toggled
    const rawDivs = dripShares * divPerShare * step;
    const reinvestedDivs = taxDrag ? rawDivs * 0.85 : rawDivs;
    const dripNewShares = reinvestedDivs / sharePrice;

    dripShares += contribShares + dripNewShares;
    noDripShares += contribShares;

    sharePrice *= priceGrowth;
    divPerShare *= divGrowth;
    totalContrib += monthly * 12 * step;
  }

  const final = data[data.length - 1];

  // Calculate Yield on Cost (YoC)
  const finalInfFactor = inflation ? Math.pow(1.03, years) : 1;
  const finalDivs = (dripShares * divPerShare) / finalInfFactor;
  const yoc = (finalDivs / totalContrib) * 100;

  return {
    data,
    final,
    snowballYear,
    milestoneHits,
    totalContributed: start + monthly * 12 * years,
    dripBonus: final.drip - final.noDrip,
    yoc,
  };
}

// ─── SHARE CARD (canvas) ─────────────────────────────────────────────────────
function drawShareCard({
  canvas,
  stock,
  start,
  monthly,
  years,
  appreciation,
  final,
  dripBonus,
  snowballYear,
  sc,
}) {
  const W = 1200,
    H = 630;
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#060612";
  ctx.fillRect(0, 0, W, H);

  const grd = ctx.createRadialGradient(W / 2, 0, 0, W / 2, 0, 500);
  grd.addColorStop(0, "#12063330");
  grd.addColorStop(1, "transparent");
  ctx.fillStyle = grd;
  ctx.fillRect(0, 0, W, H);

  ctx.strokeStyle = "rgba(255,255,255,0.03)";
  ctx.lineWidth = 1;
  for (let x = 0; x < W; x += 80) {
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, H);
    ctx.stroke();
  }
  for (let y = 0; y < H; y += 80) {
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(W, y);
    ctx.stroke();
  }

  ctx.fillStyle = sc + "22";
  ctx.strokeStyle = sc + "44";
  ctx.lineWidth = 1;
  roundRect(ctx, W / 2 - 90, 36, 180, 28, 14, true, true);
  ctx.fillStyle = sc;
  ctx.font = "bold 11px monospace";
  ctx.textAlign = "center";
  ctx.fillText("◆ DRIP SIMULATOR", W / 2, 55);

  ctx.fillStyle = sc + "22";
  ctx.strokeStyle = sc + "55";
  ctx.lineWidth = 2;
  roundRect(ctx, 70, 90, 100, 52, 10, true, true);
  ctx.fillStyle = sc;
  ctx.font = "bold 18px monospace";
  ctx.textAlign = "center";
  ctx.fillText(stock.ticker, 120, 122);

  ctx.fillStyle = "#ffffff";
  ctx.font = "600 22px sans-serif";
  ctx.textAlign = "left";
  ctx.fillText(stock.name, 190, 112);
  ctx.fillStyle = sc;
  ctx.font = "bold 14px monospace";
  ctx.fillText(
    `${stock.yield.toFixed(2)}% yield  ·  ${stock.sector}`,
    190,
    135
  );

  ctx.fillStyle = sc;
  ctx.font = "bold 92px serif";
  ctx.textAlign = "center";
  ctx.shadowColor = sc;
  ctx.shadowBlur = 40;
  ctx.fillText(fmt(final.drip), W / 2, 290);
  ctx.shadowBlur = 0;

  ctx.fillStyle = "#666";
  ctx.font = "16px monospace";
  ctx.textAlign = "center";
  ctx.fillText(`WITH DRIP IN ${years} YEARS`, W / 2, 320);

  const stats = [
    {
      label: "INVESTED",
      val: fmtFull(start + monthly * 12 * years),
      color: "#a1a1aa",
    },
    {
      label: "DRIP ADVANTAGE",
      val: `+${fmtFull(dripBonus)}`,
      color: "#FFD166",
    },
    {
      label: "MONTHLY DIVS",
      val: fmtFull(final.dividends / 12) + "/mo",
      color: sc,
    },
  ];
  stats.forEach((s, i) => {
    const bx = 70 + i * 370,
      by = 370,
      bw = 340,
      bh = 100;
    ctx.fillStyle = "rgba(255,255,255,0.04)";
    ctx.strokeStyle = "rgba(255,255,255,0.08)";
    ctx.lineWidth = 1;
    roundRect(ctx, bx, by, bw, bh, 12, true, true);
    ctx.fillStyle = "#444";
    ctx.font = "11px monospace";
    ctx.textAlign = "center";
    ctx.fillText(s.label, bx + bw / 2, by + 28);
    ctx.fillStyle = s.color;
    ctx.font = "bold 28px monospace";
    ctx.fillText(s.val, bx + bw / 2, by + 68);
  });

  if (snowballYear) {
    ctx.fillStyle = "#FFD16633";
    ctx.strokeStyle = "#FFD16666";
    ctx.lineWidth = 1;
    roundRect(ctx, W / 2 - 220, 495, 440, 34, 17, true, true);
    ctx.fillStyle = "#FFD166";
    ctx.font = "bold 13px monospace";
    ctx.textAlign = "center";
    ctx.fillText(
      `⚡ DIVIDENDS BEAT YOUR CONTRIBUTIONS AT YEAR ${snowballYear}`,
      W / 2,
      517
    );
  }

  ctx.fillStyle = "#333";
  ctx.font = "12px monospace";
  ctx.textAlign = "center";
  ctx.fillText(
    `$${start.toLocaleString()} start · $${monthly}/mo · ${
      stock.appreciation
    }%/yr app. · ${stock.dgr}%/yr div growth`,
    W / 2,
    560
  );

  ctx.fillStyle = "#222";
  ctx.font = "11px monospace";
  ctx.textAlign = "right";
  ctx.fillText(
    "dripsimulator.app · not financial advice · simulated returns",
    W - 40,
    H - 20
  );
}

function roundRect(ctx, x, y, w, h, r, fill, stroke) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
  if (fill) ctx.fill();
  if (stroke) ctx.stroke();
}

// ─── COMPONENTS ──────────────────────────────────────────────────────────────
const CustomTooltip = ({ active, payload, sc }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0]?.payload;
  if (!d) return null;
  return (
    <div
      style={{
        background: "rgba(6,6,18,0.98)",
        border: "1px solid #1a1a30",
        borderRadius: "12px",
        padding: "13px 17px",
        fontFamily: "'DM Sans',sans-serif",
        minWidth: "185px",
      }}
    >
      <div
        style={{
          color: "#94a3b8",
          fontSize: "9px",
          letterSpacing: "0.14em",
          marginBottom: "9px",
          fontFamily: "'DM Mono',monospace",
        }}
      >
        YEAR {d.yr}
      </div>
      <div
        style={{
          color: sc,
          fontSize: "18px",
          fontWeight: "700",
          marginBottom: "2px",
        }}
      >
        {fmtFull(d.drip)}
      </div>
      <div style={{ color: "#94a3b8", fontSize: "10px", marginBottom: "8px" }}>
        with DRIP
      </div>
      <div
        style={{
          color: "#a1a1aa",
          fontSize: "14px",
          fontWeight: "600",
          marginBottom: "2px",
        }}
      >
        {fmtFull(d.noDrip)}
      </div>
      <div style={{ color: "#94a3b8", fontSize: "10px", marginBottom: "7px" }}>
        without DRIP
      </div>
      <div style={{ color: "#FFD166", fontSize: "11px", fontWeight: "600" }}>
        +{fmtFull(d.drip - d.noDrip)} DRIP advantage
      </div>
    </div>
  );
};

const Slider = ({ label, value, display, onChange, min, max, step, color }) => {
  const pct = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
  return (
    <div style={{ marginBottom: "18px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px",
        }}
      >
        <span
          style={{
            fontSize: "10px",
            letterSpacing: "0.11em",
            textTransform: "uppercase",
            color: "#6b7280",
            fontFamily: "'DM Mono',monospace",
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontSize: "13px",
            fontWeight: "700",
            color,
            fontFamily: "'DM Mono',monospace",
          }}
        >
          {display}
        </span>
      </div>
      <div
        style={{
          position: "relative",
          height: "3px",
          background: "#10101e",
          borderRadius: "2px",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 0,
            width: `${pct}%`,
            height: "100%",
            background: `linear-gradient(90deg,${color}55,${color})`,
            borderRadius: "2px",
          }}
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            width: "100%",
            opacity: 0,
            cursor: "pointer",
            height: "22px",
            margin: 0,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: `${pct}%`,
            transform: "translate(-50%,-50%)",
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            background: color,
            boxShadow: `0 0 8px ${color}aa`,
            border: "2px solid #060612",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
};

const Toggle = ({ label, desc, active, onChange, color }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 14px",
      background: "rgba(255,255,255,0.02)",
      border: "1px solid rgba(255,255,255,0.04)",
      borderRadius: "10px",
      marginBottom: "10px",
      cursor: "pointer",
    }}
    onClick={() => onChange(!active)}
  >
    <div>
      <div
        style={{
          fontSize: "10px",
          color: active ? color : "#94a3b8",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          fontFamily: "'DM Mono',monospace",
          fontWeight: active ? "700" : "400",
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: "9px", color: "#6b7280", marginTop: "2px" }}>
        {desc}
      </div>
    </div>
    <div
      style={{
        width: "34px",
        height: "18px",
        borderRadius: "9px",
        background: active ? color : "#1a1a30",
        position: "relative",
        transition: "background 0.2s",
      }}
    >
      <div
        style={{
          width: "14px",
          height: "14px",
          borderRadius: "7px",
          background: "#fff",
          position: "absolute",
          top: "2px",
          left: active ? "18px" : "2px",
          transition: "left 0.2s",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
        }}
      />
    </div>
  </div>
);

// DRIP explainer
const DripExplainer = () => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (btnRef.current && !btnRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <>
      <button
        ref={btnRef}
        onClick={() => setOpen((o) => !o)}
        style={{
          background: open
            ? "rgba(255,255,255,0.08)"
            : "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "999px",
          padding: "6px 16px",
          fontSize: "11px",
          color: "#a1a1aa",
          cursor: "pointer",
          fontFamily: "'DM Mono',monospace",
          letterSpacing: "0.06em",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          transition: "all .15s ease",
        }}
      >
        <span style={{ fontSize: "13px" }}>?</span> What is DRIP?{" "}
        <span style={{ fontSize: "10px", opacity: 0.5, marginLeft: "2px" }}>
          {open ? "▲" : "▼"}
        </span>
      </button>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            zIndex: 200,
            width: "min(340px, 90vw)",
            background: "linear-gradient(145deg,#0e0e22,#0a0a18)",
            border: "1px solid rgba(125,249,166,0.2)",
            borderRadius: "18px",
            padding: "22px",
            boxShadow:
              "0 30px 80px rgba(0,0,0,0.8), 0 0 0 1px rgba(125,249,166,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "14px",
            }}
          >
            <div style={{ fontSize: "15px", fontWeight: "700", color: "#fff" }}>
              What is DRIP?
            </div>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: "none",
                border: "none",
                color: "#555",
                cursor: "pointer",
                fontSize: "18px",
                lineHeight: 1,
                padding: "0 0 0 8px",
              }}
            >
              ✕
            </button>
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#a1a1aa",
              lineHeight: 1.75,
              marginBottom: "14px",
            }}
          >
            <span style={{ color: "#7DF9A6", fontWeight: "700" }}>DRIP</span>{" "}
            stands for{" "}
            <span style={{ color: "#fff", fontWeight: "600" }}>
              Dividend ReInvestment Plan.
            </span>{" "}
            Instead of receiving your dividends as cash, they automatically buy
            more shares.
          </div>
          <button
            onClick={() => setOpen(false)}
            style={{
              width: "100%",
              background: "rgba(125,249,166,0.1)",
              border: "1px solid rgba(125,249,166,0.2)",
              borderRadius: "9px",
              padding: "9px 12px",
              fontSize: "11px",
              color: "#7DF9A6",
              cursor: "pointer",
              fontFamily: "'DM Mono',monospace",
              fontWeight: "600",
              letterSpacing: "0.06em",
            }}
          >
            Got it ✓
          </button>
        </div>
      )}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 199,
            background: "rgba(0,0,0,0.5)",
          }}
        />
      )}
    </>
  );
};

function useEntrance() {
  const [v, setV] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setV(true), 80);
    return () => clearTimeout(t);
  }, []);
  return v;
}

// ─── APP ─────────────────────────────────────────────────────────────────────
export default function DRIPSim() {
  const init = useMemo(() => readParams(), []);

  const [selectedTicker, setSelected] = useState(init.ticker);
  const [start, setStart] = useState(init.start);
  const [monthly, setMonthly] = useState(init.monthly);
  const [years, setYears] = useState(init.years);

  const [search, setSearch] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [sortBy, setSortBy] = useState("yield");

  const [customAppreciation, setCustomAppreciation] = useState(
    init.appreciation
  );
  const [customDgr, setCustomDgr] = useState(init.dgr);
  const [taxDrag, setTaxDrag] = useState(init.taxDrag);
  const [inflation, setInflation] = useState(init.inflation);

  const [shareMsg, setShareMsg] = useState("");
  const [showShareCard, setShowShareCard] = useState(false);

  const [emailInput, setEmailInput] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const canvasRef = useRef(null);
  const visible = useEntrance();

  const baseStock =
    ALL_STOCKS.find((s) => s.ticker === selectedTicker) || ALL_STOCKS[0];
  const stock = {
    ...baseStock,
    appreciation: customAppreciation ?? baseStock.appreciation,
    dgr: customDgr ?? (baseStock.dgr || 5),
  };
  const sc = SECTOR_COLORS[stock.sector] || "#7DF9A6";

  useEffect(() => {
    setCustomAppreciation(null);
    setCustomDgr(null);
  }, [selectedTicker]);

  useEffect(() => {
    try {
      if (typeof window === "undefined" || !window.history?.replaceState)
        return;
      const p = new URLSearchParams({
        ticker: selectedTicker,
        start,
        monthly,
        years,
      });
      if (
        customAppreciation !== null &&
        customAppreciation !== baseStock.appreciation
      )
        p.set("appr", customAppreciation);
      if (customDgr !== null && customDgr !== baseStock.dgr)
        p.set("dgr", customDgr);
      if (taxDrag) p.set("tax", "1");
      if (inflation) p.set("inf", "1");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${p.toString()}`
      );
    } catch {}
  }, [
    selectedTicker,
    start,
    monthly,
    years,
    customAppreciation,
    customDgr,
    taxDrag,
    inflation,
    baseStock.appreciation,
    baseStock.dgr,
  ]);

  const sim = useMemo(
    () =>
      runSim({
        start,
        monthly,
        yieldPct: stock.yield,
        appreciation: stock.appreciation,
        years,
        dgr: stock.dgr,
        taxDrag,
        inflation,
      }),
    [
      start,
      monthly,
      stock.yield,
      stock.appreciation,
      years,
      stock.dgr,
      taxDrag,
      inflation,
    ]
  );

  const {
    data,
    final,
    snowballYear,
    milestoneHits,
    totalContributed,
    dripBonus,
    yoc,
  } = sim;
  const gains = final.drip - totalContributed;
  const monthlyDiv = final.dividends / 12;
  const milestoneDots = Object.entries(milestoneHits).map(([val, yr]) => ({
    val: parseInt(val),
    yr,
  }));
  const maxVal = final.drip * 1.08,
    minVal = -(maxVal * 0.04);

  const filtered = [...ALL_STOCKS]
    .filter(
      (s) =>
        s.ticker.toLowerCase().includes(search.toLowerCase()) ||
        s.name.toLowerCase().includes(search.toLowerCase()) ||
        s.sector.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) =>
      sortBy === "yield"
        ? b.yield - a.yield
        : sortBy === "ticker"
        ? a.ticker.localeCompare(b.ticker)
        : a.name.localeCompare(b.name)
    );

  const pickStock = (ticker) => {
    setSelected(ticker);
    setShowPicker(false);
    setSearch("");
  };
  const TooltipWithSc = useMemo(
    () => (props) => <CustomTooltip {...props} sc={sc} />,
    [sc]
  );

  const copyURL = useCallback(() => {
    const url = buildShareURL(
      selectedTicker,
      start,
      monthly,
      years,
      customAppreciation,
      baseStock.appreciation,
      customDgr,
      baseStock.dgr,
      taxDrag,
      inflation
    );
    navigator.clipboard.writeText(url).then(() => {
      setShareMsg("copied");
      setTimeout(() => setShareMsg(""), 2500);
    });
  }, [
    selectedTicker,
    start,
    monthly,
    years,
    customAppreciation,
    baseStock.appreciation,
    customDgr,
    baseStock.dgr,
    taxDrag,
    inflation,
  ]);

  const downloadCard = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    drawShareCard({
      canvas,
      stock,
      start,
      monthly,
      years,
      appreciation: stock.appreciation,
      final,
      dripBonus,
      snowballYear,
      sc,
    });
    const link = document.createElement("a");
    link.download = `drip-${stock.ticker}-${years}yr.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
    setShareMsg("downloading");
    setTimeout(() => setShareMsg(""), 2000);
  }, [stock, start, monthly, years, final, dripBonus, snowballYear, sc]);

  const previewCard = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    drawShareCard({
      canvas,
      stock,
      start,
      monthly,
      years,
      appreciation: stock.appreciation,
      final,
      dripBonus,
      snowballYear,
      sc,
    });
    setShowShareCard(true);
  }, [stock, start, monthly, years, final, dripBonus, snowballYear, sc]);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    // --- PASTE YOUR BEEHIIV DATA HERE ---
    const API_KEY =
      "2kd4rj0E8UEGk7hWaJBirTYVrI6tWsIl9nTj6KpGVu91pNp1WE3xRbi79PJnyFmj";
    const PUB_ID = "4a94dad7-08f6-4220-91fc-d832fdbc46e0";
    // -------------------------------------

    if (emailInput.includes("@")) {
      try {
        const response = await fetch(
          `https://api.beehiiv.com/v2/publications/${PUB_ID}/subscriptions`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${API_KEY}`,
            },
            body: JSON.stringify({
              email: emailInput,
              utm_source: "drip-simulator.com",
              send_welcome_email: true,
            }),
          }
        );

        if (response.ok) {
          setSubscribed(true);
        } else {
          setSubscribed(true); // Still show success so user isn't stuck
          console.error("Beehiiv API Error");
        }
      } catch (err) {
        setSubscribed(true);
        console.error("Network Error:", err);
      }
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#060612",
        color: "#fff",
        fontFamily: "'DM Sans',sans-serif",
        backgroundImage:
          "radial-gradient(ellipse 60% 35% at 50% 0%,#12063340,transparent)",
      }}
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,700;1,400&family=DM+Mono:wght@400;500;700&family=Cormorant+Garamond:wght@700;800&display=swap'); *{box-sizing:border-box;margin:0;padding:0} input[type=range]{-webkit-appearance:none;appearance:none;background:transparent} input[type=text], input[type=email]{outline:none} ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-thumb{background:#1a1a30} .card{background:rgba(255,255,255,0.022);border:1px solid rgba(255,255,255,0.05);border-radius:16px} .srow{display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:9px;cursor:pointer;border:1px solid transparent;transition:all .1s} .srow:hover{background:rgba(255,255,255,0.04);border-color:rgba(255,255,255,0.07)} .srow.active{border-color:rgba(125,249,166,0.3);background:rgba(125,249,166,0.05)} @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}} .fu{animation:fadeUp .45s ease both} .s1{animation-delay:.04s}.s2{animation-delay:.1s}.s3{animation-delay:.17s}.s4{animation-delay:.24s}.s5{animation-delay:.31s} .overlay{position:fixed;inset:0;background:rgba(0,0,0,0.8);z-index:100;display:flex;align-items:center;justify-content:center;padding:14px} .modal{background:#0b0b1c;border:1px solid #1a1a2e;border-radius:18px;width:100%;max-width:520px;max-height:85vh;display:flex;flex-direction:column;overflow:hidden} .sorttab{padding:5px 12px;font-size:10px;font-family:'DM Mono',monospace;letter-spacing:.1em;border-radius:6px;border:1px solid transparent;cursor:pointer;transition:all .12s;color:#555;background:transparent} .sorttab.active{color:#fff;background:rgba(255,255,255,0.08);border-color:rgba(255,255,255,0.1)} .pill{display:inline-flex;align-items:center;gap:5px;padding:4px 12px;border-radius:100px;font-size:10px;font-family:'DM Mono',monospace;font-weight:600} .fchip{display:flex;flex-direction:column;align-items:flex-start;padding:9px 12px;border-radius:10px;cursor:pointer;border:1px solid rgba(255,255,255,0.06);background:rgba(255,255,255,0.03);transition:all .12s;gap:2px} .fchip:hover{background:rgba(255,255,255,0.06);border-color:rgba(255,255,255,0.12);transform:translateY(-1px)} .fchip.active{border-color:rgba(125,249,166,0.4);background:rgba(125,249,166,0.06)} .sharebtn{display:flex;align-items:center;gap:7px;padding:10px 18px;border-radius:10px;font-size:12px;font-weight:700;cursor:pointer;font-family:'DM Sans',sans-serif;transition:all .15s;border:none} .sharebtn:hover{transform:translateY(-1px)}`}</style>

      <canvas ref={canvasRef} style={{ display: "none" }} />

      {showShareCard && (
        <div className="overlay" onClick={() => setShowShareCard(false)}>
          <div
            style={{
              background: "#0b0b1c",
              border: "1px solid #1a1a2e",
              borderRadius: "18px",
              padding: "20px",
              maxWidth: "640px",
              width: "100%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "14px",
              }}
            >
              <div style={{ fontSize: "13px", fontWeight: "700" }}>
                Your Share Card
              </div>
              <button
                onClick={() => setShowShareCard(false)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#6b7280",
                  cursor: "pointer",
                  fontSize: "18px",
                }}
              >
                ✕
              </button>
            </div>
            <img
              src={canvasRef.current?.toDataURL("image/png")}
              alt="share card"
              style={{
                width: "100%",
                borderRadius: "10px",
                border: "1px solid #1a1a2e",
              }}
            />
            <div style={{ display: "flex", gap: "10px", marginTop: "14px" }}>
              <button
                className="sharebtn"
                onClick={downloadCard}
                style={{ background: sc, color: "#060612", flex: 1 }}
              >
                ↓ Download PNG
              </button>
              <button
                className="sharebtn"
                onClick={copyURL}
                style={{
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.1)",
                  flex: 1,
                }}
              >
                {shareMsg === "copied" ? "✓ Copied!" : "🔗 Copy Link"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPicker && (
        <div className="overlay" onClick={() => setShowPicker(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                padding: "18px 18px 14px",
                borderBottom: "1px solid #131326",
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "12px",
                }}
              >
                <div>
                  <div style={{ fontSize: "13px", fontWeight: "700" }}>
                    S&P 500 Dividend Stocks
                  </div>
                  <div
                    style={{
                      fontSize: "9px",
                      color: "#94a3b8",
                      marginTop: "2px",
                    }}
                  >
                    {ALL_STOCKS.length} stocks
                  </div>
                </div>
                <button
                  onClick={() => setShowPicker(false)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#6b7280",
                    cursor: "pointer",
                    fontSize: "18px",
                    lineHeight: 1,
                  }}
                >
                  ✕
                </button>
              </div>
              <input
                type="text"
                placeholder="Search ticker, name, or sector…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "100%",
                  background: "rgba(255,255,255,0.04)",
                  border: "1px solid #1a1a2e",
                  borderRadius: "9px",
                  padding: "9px 13px",
                  color: "#fff",
                  fontSize: "12px",
                  fontFamily: "'DM Sans',sans-serif",
                  marginBottom: "10px",
                }}
              />
              <div style={{ display: "flex", gap: "6px" }}>
                {["yield", "ticker", "name"].map((s) => (
                  <button
                    key={s}
                    className={`sorttab${sortBy === s ? " active" : ""}`}
                    onClick={() => setSortBy(s)}
                  >
                    {s === "yield"
                      ? "↓ YIELD"
                      : s === "ticker"
                      ? "A-Z TICKER"
                      : "A-Z NAME"}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ overflowY: "auto", padding: "14px 16px 18px" }}>
              {!search && (
                <div style={{ marginBottom: "18px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "9px",
                        letterSpacing: "0.18em",
                        color: "#FFD166",
                        textTransform: "uppercase",
                        fontFamily: "'DM Mono',monospace",
                        fontWeight: "700",
                      }}
                    >
                      ⭐ Most Popular & Trusted
                    </div>
                    <div
                      style={{
                        flex: 1,
                        height: "1px",
                        background: "rgba(255,209,102,0.12)",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3,1fr)",
                      gap: "6px",
                    }}
                  >
                    {FEATURED.map((f) => {
                      const s = ALL_STOCKS.find((x) => x.ticker === f.ticker);
                      if (!s) return null;
                      const c = SECTOR_COLORS[s.sector] || "#7DF9A6";
                      return (
                        <div
                          key={f.ticker}
                          className={`fchip${
                            selectedTicker === f.ticker ? " active" : ""
                          }`}
                          onClick={() => pickStock(f.ticker)}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "22px",
                                borderRadius: "5px",
                                background: `${c}18`,
                                border: `1px solid ${c}28`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "7px",
                                fontWeight: "700",
                                color: c,
                                fontFamily: "'DM Mono',monospace",
                                flexShrink: 0,
                              }}
                            >
                              {f.ticker.slice(0, 4)}
                            </div>
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {f.label}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              marginTop: "2px",
                            }}
                          >
                            <span style={{ fontSize: "9px", color: "#94a3b8" }}>
                              {f.tag}
                            </span>
                            <span
                              style={{
                                fontSize: "10px",
                                fontWeight: "700",
                                color: c,
                                fontFamily: "'DM Mono',monospace",
                              }}
                            >
                              {s.yield.toFixed(2)}%
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {!search && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "9px",
                      letterSpacing: "0.18em",
                      color: "#94a3b8",
                      textTransform: "uppercase",
                      fontFamily: "'DM Mono',monospace",
                    }}
                  >
                    All Dividend Stocks
                  </div>
                  <div
                    style={{
                      flex: 1,
                      height: "1px",
                      background: "rgba(255,255,255,0.05)",
                    }}
                  />
                </div>
              )}
              <div
                style={{ display: "flex", flexDirection: "column", gap: "3px" }}
              >
                {filtered.map((s) => {
                  const c = SECTOR_COLORS[s.sector] || "#7DF9A6";
                  return (
                    <div
                      key={s.ticker}
                      className={`srow${
                        s.ticker === selectedTicker ? " active" : ""
                      }`}
                      onClick={() => pickStock(s.ticker)}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "30px",
                          borderRadius: "7px",
                          background: `${c}14`,
                          border: `1px solid ${c}28`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "8px",
                          fontWeight: "700",
                          color: c,
                          fontFamily: "'DM Mono',monospace",
                          flexShrink: 0,
                        }}
                      >
                        {s.ticker.slice(0, 4)}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {s.name}
                        </div>
                        <div
                          style={{
                            fontSize: "9px",
                            color: "#94a3b8",
                            marginTop: "1px",
                          }}
                        >
                          {s.sector}
                        </div>
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0 }}>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            color: c,
                            fontFamily: "'DM Mono',monospace",
                          }}
                        >
                          {s.yield.toFixed(2)}%
                        </div>
                        <div style={{ fontSize: "8px", color: "#4b5563" }}>
                          yield
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        style={{ textAlign: "center", padding: "44px 20px 20px" }}
        className={visible ? "fu" : ""}
      >
        <div
          style={{
            display: "inline-block",
            background: "rgba(125,249,166,0.07)",
            border: "1px solid rgba(125,249,166,0.13)",
            borderRadius: "100px",
            padding: "4px 13px",
            fontSize: "9px",
            letterSpacing: "0.28em",
            color: "#7DF9A6",
            textTransform: "uppercase",
            marginBottom: "16px",
            fontFamily: "'DM Mono',monospace",
          }}
        >
          ◆ DRIP SIMULATOR
        </div>
        <h1
          style={{
            fontFamily: "'Cormorant Garamond',serif",
            fontSize: "clamp(28px,6vw,56px)",
            fontWeight: "800",
            lineHeight: 1.05,
            marginBottom: "10px",
          }}
        >
          Watch Your Money
          <br />
          <span style={{ color: "#7DF9A6", textShadow: "0 0 40px #7DF9A644" }}>
            Snowball.
          </span>
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "12px",
          }}
        >
          <DripExplainer />
        </div>
      </div>

      <div
        style={{
          maxWidth: "980px",
          margin: "0 auto",
          padding: "0 14px 60px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        <div
          className="card fu s1"
          style={{
            padding: "14px 18px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "11px",
              flex: 1,
              minWidth: "180px",
            }}
          >
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "9px",
                background: `${sc}15`,
                border: `1px solid ${sc}28`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "9px",
                fontWeight: "700",
                color: sc,
                fontFamily: "'DM Mono',monospace",
                flexShrink: 0,
              }}
            >
              {stock.ticker.slice(0, 4)}
            </div>
            <div>
              <div style={{ fontSize: "14px", fontWeight: "700" }}>
                {stock.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginTop: "3px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <span
                  className="pill"
                  style={{ background: `${sc}14`, color: sc }}
                >
                  {stock.yield.toFixed(2)}% yield
                </span>
                <span style={{ fontSize: "10px", color: "#4b5563" }}>
                  {stock.sector}
                </span>
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowPicker(true)}
            style={{
              background: `${sc}14`,
              color: sc,
              border: `1px solid ${sc}28`,
              borderRadius: "9px",
              padding: "9px 16px",
              fontSize: "11px",
              fontWeight: "700",
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
              whiteSpace: "nowrap",
            }}
          >
            Change Stock ↓
          </button>
        </div>

        <div
          className="fu s2"
          style={{ textAlign: "center", padding: "20px 16px 14px" }}
        >
          <div
            style={{
              color: "#4b5563",
              fontSize: "9px",
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              marginBottom: "9px",
              fontFamily: "'DM Mono',monospace",
            }}
          >
            With DRIP in {years} years
          </div>
          <div
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontWeight: "800",
              fontSize: "clamp(44px,11vw,92px)",
              color: sc,
              lineHeight: 1,
              textShadow: `0 0 70px ${sc}30`,
            }}
          >
            {fmt(final.drip)}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "6px",
              marginTop: "11px",
              flexWrap: "wrap",
            }}
          >
            {snowballYear && (
              <span
                className="pill"
                style={{
                  background: "rgba(255,209,102,0.1)",
                  border: "1px solid rgba(255,209,102,0.2)",
                  color: "#FFD166",
                }}
              >
                ⚡ Dividends beat contributions at yr {snowballYear}
              </span>
            )}
            <span
              className="pill"
              style={{
                background: `${sc}10`,
                border: `1px solid ${sc}20`,
                color: sc,
              }}
            >
              {fmtFull(monthlyDiv)}/mo in dividends
            </span>
            <span
              className="pill"
              style={{
                background: `rgba(167, 139, 250, 0.1)`,
                border: `1px solid rgba(167, 139, 250, 0.2)`,
                color: "#a78bfa",
              }}
            >
              {yoc.toFixed(1)}% Yield on Cost
            </span>
          </div>
        </div>

        <div
          className="fu s3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3,1fr)",
            gap: "8px",
          }}
        >
          {[
            {
              label: "You Put In",
              val: fmtFull(totalContributed),
              color: "#666",
              note: "total invested",
            },
            {
              label: "DRIP Advantage",
              val: `+${fmtFull(dripBonus)}`,
              color: "#FFD166",
              note: "vs no reinvestment",
            },
            {
              label: "Total Gains",
              val: fmtFull(gains),
              color: sc,
              note: "above contributions",
            },
          ].map((s, i) => (
            <div
              key={i}
              className="card"
              style={{ padding: "13px 11px", textAlign: "center" }}
            >
              <div
                style={{
                  fontSize: "8px",
                  letterSpacing: "0.14em",
                  color: "#4b5563",
                  textTransform: "uppercase",
                  fontFamily: "'DM Mono',monospace",
                  marginBottom: "5px",
                }}
              >
                {s.label}
              </div>
              <div
                style={{
                  fontSize: "clamp(11px,2vw,16px)",
                  fontWeight: "700",
                  color: s.color,
                  fontFamily: "'DM Mono',monospace",
                }}
              >
                {s.val}
              </div>
              <div
                style={{ fontSize: "8px", color: "#6b7280", marginTop: "3px" }}
              >
                {s.note}
              </div>
            </div>
          ))}
        </div>

        <div className="card fu s4" style={{ padding: "20px 6px 10px" }}>
          <div
            style={{
              paddingLeft: "18px",
              marginBottom: "14px",
              display: "flex",
              justifyContent: "space-between",
              paddingRight: "18px",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "6px",
            }}
          >
            <div
              style={{
                fontSize: "9px",
                letterSpacing: "0.15em",
                color: "#4b5563",
                textTransform: "uppercase",
                fontFamily: "'DM Mono',monospace",
              }}
            >
              Growth Curve
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              {[
                [sc, "With DRIP"],
                ["#3a3a5a", "Without DRIP"],
              ].map(([c, l]) => (
                <div
                  key={l}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontSize: "9px",
                    color: "#6b7280",
                  }}
                >
                  <div
                    style={{
                      width: "14px",
                      height: "2px",
                      background: c,
                      borderRadius: "1px",
                    }}
                  />
                  {l}
                </div>
              ))}
            </div>
          </div>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart
              data={data}
              margin={{ top: 12, right: 18, bottom: 0, left: 0 }}
            >
              <defs>
                <linearGradient id="gD" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={sc} stopOpacity={0.28} />
                  <stop offset="75%" stopColor={sc} stopOpacity={0.08} />
                  <stop offset="100%" stopColor={sc} stopOpacity={0} />
                </linearGradient>
                <linearGradient id="gN" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#3a3a5a" stopOpacity={0.22} />
                  <stop offset="100%" stopColor="#3a3a5a" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis
                dataKey="yr"
                stroke="transparent"
                tick={{
                  fill: "#333",
                  fontSize: 8,
                  fontFamily: "'DM Mono',monospace",
                }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="transparent"
                tick={{
                  fill: "#333",
                  fontSize: 8,
                  fontFamily: "'DM Mono',monospace",
                }}
                tickLine={false}
                axisLine={false}
                domain={[minVal, maxVal]}
                tickFormatter={(v) =>
                  v <= 0
                    ? ""
                    : v >= 1e6
                    ? `${(v / 1e6).toFixed(1)}M`
                    : v >= 1e3
                    ? `${(v / 1e3).toFixed(0)}K`
                    : v
                }
                width={42}
              />
              <Tooltip
                content={TooltipWithSc}
                cursor={{ stroke: "#1e1e36", strokeWidth: 1 }}
              />
              {milestoneDots.map(({ val, yr }) => (
                <ReferenceDot
                  key={val}
                  x={yr}
                  y={val}
                  r={3}
                  fill={sc}
                  stroke="#060612"
                  strokeWidth={2}
                  label={{
                    value: fmt(val),
                    position: "top",
                    fill: sc,
                    fontSize: 8,
                    fontFamily: "'DM Mono',monospace",
                  }}
                />
              ))}
              <Area
                type="monotone"
                dataKey="noDrip"
                stroke="#3a3a5a"
                strokeWidth={1.8}
                fill="url(#gN)"
                dot={false}
                strokeDasharray="5 3"
              />
              <Area
                type="monotone"
                dataKey="drip"
                stroke={sc}
                strokeWidth={3}
                fill="url(#gD)"
                dot={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div
          className="fu s5"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          <div className="card" style={{ padding: "22px 20px" }}>
            <div
              style={{
                fontSize: "9px",
                letterSpacing: "0.14em",
                color: "#4b5563",
                textTransform: "uppercase",
                fontFamily: "'DM Mono',monospace",
                marginBottom: "18px",
              }}
            >
              Your Numbers
            </div>
            <Slider
              label="Starting Amount"
              value={start}
              display={`$${start.toLocaleString()}`}
              onChange={setStart}
              min={500}
              max={150000}
              step={500}
              color={sc}
            />
            <Slider
              label="Monthly Contribution"
              value={monthly}
              display={`$${monthly}/mo`}
              onChange={setMonthly}
              min={0}
              max={5000}
              step={50}
              color={sc}
            />
            <Slider
              label="Time Horizon"
              value={years}
              display={`${years} yrs`}
              onChange={setYears}
              min={5}
              max={40}
              step={1}
              color={sc}
            />

            <div
              style={{
                marginTop: "24px",
                paddingTop: "18px",
                borderTop: "1px solid rgba(255,255,255,0.05)",
              }}
            >
              <div
                style={{
                  fontSize: "9px",
                  letterSpacing: "0.14em",
                  color: "#4b5563",
                  textTransform: "uppercase",
                  fontFamily: "'DM Mono',monospace",
                  marginBottom: "10px",
                }}
              >
                Real Return Adjustments
              </div>
              <Toggle
                label="Adjust for Inflation"
                desc="Discounts final numbers by 3% annually"
                active={inflation}
                onChange={setInflation}
                color="#FFD166"
              />
              <Toggle
                label="Apply Dividend Tax"
                desc="Subtracts 15% from divs before reinvesting"
                active={taxDrag}
                onChange={setTaxDrag}
                color="#f87171"
              />
            </div>
          </div>

          <div className="card" style={{ padding: "22px 20px" }}>
            <div
              style={{
                fontSize: "9px",
                letterSpacing: "0.14em",
                color: "#4b5563",
                textTransform: "uppercase",
                fontFamily: "'DM Mono',monospace",
                marginBottom: "4px",
              }}
            >
              Stock Assumption
            </div>
            <div
              style={{
                fontSize: "9px",
                color: "#6b7280",
                marginBottom: "20px",
              }}
            >
              Pre-filled from {stock.ticker} · drag to adjust
            </div>
            <Slider
              label="Stock Price Appreciation"
              value={stock.appreciation}
              display={`${stock.appreciation.toFixed(1)}%/yr`}
              onChange={(v) => setCustomAppreciation(parseFloat(v.toFixed(1)))}
              min={0}
              max={25}
              step={0.5}
              color="#a78bfa"
            />
            <Slider
              label="Dividend Growth Rate (DGR)"
              value={stock.dgr}
              display={`${stock.dgr.toFixed(1)}%/yr`}
              onChange={(v) => setCustomDgr(parseFloat(v.toFixed(1)))}
              min={0}
              max={20}
              step={0.5}
              color="#38bdf8"
            />

            <div
              style={{
                padding: "12px 14px",
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.04)",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#94a3b8",
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      fontFamily: "'DM Mono',monospace",
                    }}
                  >
                    Starting Div Yield
                  </div>
                  <div
                    style={{
                      fontSize: "9px",
                      color: "#6b7280",
                      marginTop: "2px",
                    }}
                  >
                    live rate from {stock.ticker}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: sc,
                    fontFamily: "'DM Mono',monospace",
                  }}
                >
                  {stock.yield.toFixed(2)}%
                </div>
              </div>
            </div>
            {(customAppreciation !== null || customDgr !== null) && (
              <button
                onClick={() => {
                  setCustomAppreciation(null);
                  setCustomDgr(null);
                }}
                style={{
                  marginTop: "12px",
                  background: "none",
                  border: "1px solid #1a1a30",
                  borderRadius: "7px",
                  padding: "6px 12px",
                  fontSize: "9px",
                  color: "#94a3b8",
                  cursor: "pointer",
                  fontFamily: "'DM Mono',monospace",
                  letterSpacing: "0.1em",
                  width: "100%",
                }}
              >
                ↺ RESET TO {stock.ticker} DEFAULTS
              </button>
            )}
          </div>
        </div>

        <div
          className="card"
          style={{
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, minWidth: "160px" }}>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "700",
                marginBottom: "2px",
              }}
            >
              Share your simulation
            </div>
            <div style={{ fontSize: "10px", color: "#94a3b8" }}>
              Post to Reddit r/dividends · r/Fire · Twitter/X
            </div>
          </div>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <button
              className="sharebtn"
              onClick={previewCard}
              style={{
                background: `${sc}18`,
                color: sc,
                border: `1px solid ${sc}33`,
              }}
            >
              📸 Generate Card
            </button>
            <button
              className="sharebtn"
              onClick={copyURL}
              style={{
                background: "rgba(255,255,255,0.05)",
                color: "#ccc",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              {shareMsg === "copied" ? "✓ Link Copied!" : "🔗 Copy Link"}
            </button>
          </div>
        </div>

        {/* ── CTA / NEWSLETTER LEAD GEN ── */}
        <div
          style={{
            background: "linear-gradient(135deg,#0a1f0f,#0c0c18 55%,#130820)",
            border: "1px solid rgba(125,249,166,0.08)",
            borderRadius: "18px",
            padding: "30px 22px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: "9px",
              letterSpacing: "0.22em",
              color: sc,
              textTransform: "uppercase",
              marginBottom: "10px",
              fontFamily: "'DM Mono',monospace",
            }}
          >
            Reach Your Goal Faster
          </div>
          <div
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontSize: "clamp(17px,3.5vw,26px)",
              fontWeight: "700",
              marginBottom: "7px",
              lineHeight: 1.2,
            }}
          >
            Want to build a {fmt(final.drip)} portfolio?
            <br />
            Get our top 5 dividend picks every week.
          </div>
          <p
            style={{
              color: "#94a3b8",
              fontSize: "12px",
              marginBottom: "20px",
              lineHeight: 1.7,
            }}
          >
            Join 50,000+ investors receiving the free{" "}
            <i>Dividend Growth Report</i>. No spam, just math.
          </p>

          {!subscribed ? (
            <form
              onSubmit={handleSubscribe}
              style={{
                display: "flex",
                gap: "8px",
                maxWidth: "380px",
                margin: "0 auto",
                flexDirection: "row",
              }}
            >
              <input
                type="email"
                placeholder="Enter your email address..."
                required
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                style={{
                  flex: 1,
                  background: "rgba(255,255,255,0.05)",
                  border: `1px solid rgba(255,255,255,0.1)`,
                  borderRadius: "10px",
                  padding: "13px 18px",
                  fontSize: "13px",
                  color: "#fff",
                  fontFamily: "'DM Sans',sans-serif",
                }}
              />
              <button
                type="submit"
                style={{
                  background: sc,
                  color: "#060612",
                  border: "none",
                  borderRadius: "10px",
                  padding: "13px 22px",
                  fontSize: "13px",
                  fontWeight: "700",
                  cursor: "pointer",
                  fontFamily: "'DM Sans',sans-serif",
                  transition: "opacity .14s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = ".85")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                Get Free Report
              </button>
            </form>
          ) : (
            <div
              style={{
                background: `${sc}15`,
                border: `1px solid ${sc}33`,
                borderRadius: "10px",
                padding: "16px",
                maxWidth: "380px",
                margin: "0 auto",
                color: sc,
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              ✓ You're on the list! Check your inbox.
            </div>
          )}

          <div
            style={{
              fontSize: "8px",
              color: "#6b7280",
              letterSpacing: "0.06em",
              marginTop: "16px",
            }}
          >
            FREE WEEKLY NEWSLETTER · UNSUBSCRIBE ANYTIME
          </div>
        </div>
      </div>
    </div>
  );
}
